import { assetsSchemasQuery, searchAssetsSchemas } from '@atlassian/search-client';

import { ProductKeys, type ProductKeys1P } from '../../../../../common/constants/products';
import { createMultiSelectFilter } from '../../../../filters/multi-select-filter';

const productKeys1P: ProductKeys1P[] = [ProductKeys.Assets];

export const filter = createMultiSelectFilter({
	id: 'assetsSchema',
	products: productKeys1P,
	alwaysVisible: false,
	universal: false,
	queryParams: {
		key: 'assetsSchema',
		fetcher: async (queryParams, config) => {
			const allSchemas = await assetsSchemasQuery(queryParams);
			const hydratedSchemaOptions = allSchemas.data?.assets_schemasByIds?.map((schema) => {
				return {
					trackingKey: schema.id,
					value: schema.id,
					queryParamValue: schema.id,
					label: schema.name || '',
					product: config.product,
					isSuggested: false,
					isSelected: false,
				};
			});

			return hydratedSchemaOptions ?? [];
		},
	},
	initialOptions: {
		fetcher: async (config) => {
			const suggestedSchemas = await searchAssetsSchemas();
			const recommendedSchemaOptions = suggestedSchemas.map((schema) => {
				return {
					trackingKey: schema.ari,
					value: schema.ari,
					queryParamValue: schema.ari,
					label: schema.name || '',
					product: config.product,
					isSuggested: true,
					isSelected: false,
				};
			});

			return recommendedSchemaOptions;
		},
	},
	lookup: {
		fetcher: async (query, config) => {
			const resultSchemas = await searchAssetsSchemas(query);
			const searchSchemaOptions = resultSchemas.map((schema) => {
				return {
					trackingKey: schema.ari,
					value: schema.ari,
					queryParamValue: schema.ari,
					label: schema.name || '',
					product: config.product,
					isSuggested: false,
					isSelected: false,
				};
			});
			return searchSchemaOptions;
		},
	},
	isSuggestedFilter: (primaryProduct) => primaryProduct === ProductKeys.Assets,
});
